import {
  requestPendingList,
  requestShippedList,
  requestUndecidedList,
} from '@/api/pending';

const state = {
  pendingList: null,
  shippedList: null,
  undecidedList: null,
};

const getters = {
  pendingList: (state) => state.pendingList,
  shippedList: (state) => state.shippedList,
  undecidedList: (state) => state.undecidedList,
};

const actions = {
  async setPendingList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestPendingList({ pageNumber });
    commit('setPendingList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setShippedList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestShippedList({ pageNumber });
    commit('setShippedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
  async setUndecidedList({ commit, dispatch }, { pageNumber }) {
    await dispatch('setIsLoading', true, { root: true });
    const result = await requestUndecidedList({ pageNumber });
    commit('setUndecidedList', result.data);
    await dispatch('setIsLoading', false, { root: true });
  },
};

const mutations = {
  setPendingList(state, pendingList) {
    state.pendingList = pendingList;
  },
  setShippedList(state, shippedList) {
    state.shippedList = shippedList;
  },
  setUndecidedList(state, undecidedList) {
    state.undecidedList = undecidedList;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
